import { render, staticRenderFns } from "./prevfour.vue?vue&type=template&id=ad19cbca&"
import script from "./prevfour.vue?vue&type=script&lang=ts&"
export * from "./prevfour.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports